import { Button } from "@mui/material"
import React from "react"
import { useAppSelector } from "../../../../../../app/hooks";
import { useCaseManStatusUpdateMutation } from "../../../../../../services/caseManService/caseManage-api";
import { CaseManStatusUpdateCommand } from "../../../../../../services/caseManService/commands";

function PendingReviewBtn(){
    const caseManage = useAppSelector((state)=>state.caseManagement.caseManagement);
    const [saveStatus] = useCaseManStatusUpdateMutation();
    const handleSave=()=>{
        let command = new CaseManStatusUpdateCommand(caseManage,'Clinical','Pending');
        saveStatus(command);
    }
    return <React.Fragment>
        <Button variant='outlined' color='primary'
            onClick={()=>handleSave()}
            disabled={caseManage.clinicalReviewStatus === 'Pending'}>Pend</Button>
    </React.Fragment>
}

export {PendingReviewBtn}